import { useMemo } from 'react';
import { Content, Language } from '../types';
import contentData from '../data/content.json';

// Whole years since the career started, so "{years}+" copy never goes stale.
const yearsSince = (start: string, now = new Date()) => {
  const [year, month] = start.split('-').map(Number);
  return now.getFullYear() - year - (now.getMonth() + 1 < month ? 1 : 0);
};

const fill = <T,>(value: T, years: string): T => {
  if (typeof value === 'string') return value.replace(/\{years\}/g, years) as T;
  if (Array.isArray(value)) return value.map(item => fill(item, years)) as T;
  if (value && typeof value === 'object') {
    return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, fill(item, years)])) as T;
  }
  return value;
};

export const useContent = (language: Language): Content =>
  useMemo(() => {
    const content: Content = contentData[language];
    return fill(content, String(yearsSince(content.personalInfo.careerStart)));
  }, [language]);
